import { authState, UserPermission } from 'state/auth';
import lodash from 'lodash';

export default function hasPermission(permissions: UserPermission[]): boolean {
  const currentUser = authState().user;
  if (permissions.length === 0) {
    return true;
  }
  const userPerms = currentUser?.role?.permissions || [];
  return userPerms.includes('*') || lodash.intersection(permissions, userPerms).length > 0;
}
